import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { isProd } from 'helpers/helper';
import { UserContext } from 'contexts/user/UserContext';

const Home = (): React.ReactElement => {
  const { isAuthenticated } = useContext(UserContext);
  const history = useHistory();
  const landingPage = import.meta.env.VITE_HOME_URL || (isProd ? '/about' : '/login');
  isAuthenticated ? history.push('/profile') : (window.location.href = landingPage);
  return <div className="loading" />;
};

export default Home;
